import { CLIENT_VERSION } from './version';

export const environment = {
  production: false,
  apiBaseUrl: 'https://api.leah.dev.sprintwerk.de',
  version: CLIENT_VERSION,
};
